import { useToggle, useTranslation } from '@starsoft/common/hooks';
import { Button } from '@starsoft/common/components/Button';
import { TransactionsCommonMappingModal } from './Modal';
import { useRef } from 'react';

/**
 * TransactionsMapping Component
 * This component renders a button that toggles the visibility of a modal.
 * It uses a ref to track the button's bounding rectangle for positioning the modal.
 *
 * @returns {JSX.Element} The rendered component with a button and a modal.
 *
 * @example
 * // Usage example:
 * <TransactionsMapping />
 */
export function TransactionsMapping() {
  // Reference to the button element to get its bounding rectangle
  const ref = useRef<HTMLButtonElement>();
  // Hook to handle translations for the 'common' namespace
  const { t } = useTranslation('common');
  // Hook to manage the open state of the modal
  const [open, toggleOpen] = useToggle(false);

  // Get the bounding rectangle of the button for modal positioning
  const boundings = ref?.current?.getBoundingClientRect?.();

  return (
    <>
      {/* Button to toggle the modal open state */}
      <Button onClick={toggleOpen} useMaxContent ref={ref}>
        <i className="fa-solid fa-share-nodes" />
        {t('transaction_mapping_button')}
      </Button>
      {/* Modal component that displays when the button is clicked */}
      <TransactionsCommonMappingModal
        open={open}
        onClose={toggleOpen}
        boundings={boundings}
      />
    </>
  );
}
